module.exports = __webpack_public_path__ + "static/media/quindio-71.dd853aeb.jpg";